import React from 'react';
import { Box, Typography } from '@mui/material';

function Page2SubPageE() {
  return (
    <Box p={4}>
      <Typography variant="h4">Jurisprudence</Typography>
    </Box>
  );
}

export default Page2SubPageE;
